import LoadsRounds from './loads-rounds';

export default LoadsRounds;
